// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file events/v1/events.proto (package events.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Creator, CreatorJson, DataType, DataTypeJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file events/v1/events.proto.
 */
export const file_events_v1_events: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChZldmVudHMvdjEvZXZlbnRzLnByb3RvEglldmVudHMudjEi9wEKCENhbGVuZGFyEgoKAmlkGAEgASgJEg4KBm9yZ19pZBgCIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAyABKAkSIwoHY3JlYXRvchgEIAEoCzISLmNvbW1vbi52MS5DcmVhdG9yEgwKBG5hbWUYBSABKAkSEgoKY29sb3JfY29kZRgGIAEoCRISCgppc19kZWZhdWx0GAcgASgIEi4KCmNyZWF0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIrEECgVFdmVudBIKCgJpZBgBIAEoCRIOCgZvcmdfaWQYAiABKAkSFAoMd29ya3NwYWNlX2lkGAMgASgJEiUKCGNhbGVuZGFyGAQgASgLMhMuZXZlbnRzLnYxLkNhbGVuZGFyEiMKB2NyZWF0b3IYBSABKAsyEi5jb21tb24udjEuQ3JlYXRvchINCgV0aXRsZRgGIAEoCRIYCgtkZXNjcmlwdGlvbhgHIAEoCUgAiAEBEhIKBWltYWdlGBEgASgJSAGIAQESDwoHYWxsX2RheRgIIAEoCBIuCgpzdGFydF90aW1lGAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghlbmRfdGltZRgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEAoIdGltZXpvbmUYCyABKAkSFwoPcmVjdXJyZW5jZV9ydWxlGAwgASgJEhwKD3BhcmVudF9ldmVudF9pZBgNIAEoCUgCiAEBEicKCnByb3BlcnRpZXMYDiADKAsyEy5ldmVudHMudjEuUHJvcGVydHkSLgoKY3JlYXRlZF9hdBgPIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgQIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCDgoMX2Rlc2NyaXB0aW9uQggKBl9pbWFnZUISChBfcGFyZW50X2V2ZW50X2lkImEKCFByb3BlcnR5EgsKA2tleRgBIAEoCRIhCgR0eXBlGAIgASgOMhMuY29tbW9uLnYxLkRhdGFUeXBlEiUKBXZhbHVlGAMgASgLMhYuZ29vZ2xlLnByb3RvYnVmLlZhbHVlYgZwcm90bzM",
		[file_common_v1_types, file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * @generated from message events.v1.Calendar
 */
export type Calendar = Message<"events.v1.Calendar"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 4;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string name = 5;
	 */
	name: string;

	/**
	 * @generated from field: string color_code = 6;
	 */
	colorCode: string;

	/**
	 * @generated from field: bool is_default = 7;
	 */
	isDefault: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message events.v1.Calendar
 */
export type CalendarJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 4;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string name = 5;
	 */
	name?: string;

	/**
	 * @generated from field: string color_code = 6;
	 */
	colorCode?: string;

	/**
	 * @generated from field: bool is_default = 7;
	 */
	isDefault?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message events.v1.Calendar.
 * Use `create(CalendarSchema)` to create a new message.
 */
export const CalendarSchema: GenMessage<Calendar, { jsonType: CalendarJson }> = /*@__PURE__*/ messageDesc(file_events_v1_events, 0);

/**
 * @generated from message events.v1.Event
 */
export type Event = Message<"events.v1.Event"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: events.v1.Calendar calendar = 4;
	 */
	calendar?: Calendar | undefined;

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string title = 6;
	 */
	title: string;

	/**
	 * @generated from field: optional string description = 7;
	 */
	description?: string | undefined;

	/**
	 * @generated from field: optional string image = 17;
	 */
	image?: string | undefined;

	/**
	 * @generated from field: bool all_day = 8;
	 */
	allDay: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 9;
	 */
	startTime?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 10;
	 */
	endTime?: Timestamp | undefined;

	/**
	 * @generated from field: string timezone = 11;
	 */
	timezone: string;

	/**
	 * @generated from field: string recurrence_rule = 12;
	 */
	recurrenceRule: string;

	/**
	 * @generated from field: optional string parent_event_id = 13;
	 */
	parentEventId?: string | undefined;

	/**
	 * @generated from field: repeated events.v1.Property properties = 14;
	 */
	properties: Property[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message events.v1.Event
 */
export type EventJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: events.v1.Calendar calendar = 4;
	 */
	calendar?: CalendarJson;

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string title = 6;
	 */
	title?: string;

	/**
	 * @generated from field: optional string description = 7;
	 */
	description?: string;

	/**
	 * @generated from field: optional string image = 17;
	 */
	image?: string;

	/**
	 * @generated from field: bool all_day = 8;
	 */
	allDay?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 9;
	 */
	startTime?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 10;
	 */
	endTime?: TimestampJson;

	/**
	 * @generated from field: string timezone = 11;
	 */
	timezone?: string;

	/**
	 * @generated from field: string recurrence_rule = 12;
	 */
	recurrenceRule?: string;

	/**
	 * @generated from field: optional string parent_event_id = 13;
	 */
	parentEventId?: string;

	/**
	 * @generated from field: repeated events.v1.Property properties = 14;
	 */
	properties?: PropertyJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 15;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 16;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message events.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event, { jsonType: EventJson }> = /*@__PURE__*/ messageDesc(file_events_v1_events, 1);

/**
 * @generated from message events.v1.Property
 */
export type Property = Message<"events.v1.Property"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: common.v1.DataType type = 2;
	 */
	type: DataType;

	/**
	 * @generated from field: google.protobuf.Value value = 3;
	 */
	value?: Value | undefined;
};

/**
 * @generated from message events.v1.Property
 */
export type PropertyJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: common.v1.DataType type = 2;
	 */
	type?: DataTypeJson;

	/**
	 * @generated from field: google.protobuf.Value value = 3;
	 */
	value?: ValueJson;
};

/**
 * Describes the message events.v1.Property.
 * Use `create(PropertySchema)` to create a new message.
 */
export const PropertySchema: GenMessage<Property, { jsonType: PropertyJson }> = /*@__PURE__*/ messageDesc(file_events_v1_events, 2);
